import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit {

  options = [
	  {Nombre:'dato1' , ID: 1001},
	  {Nombre:'dato2' , ID: 1002},
	  {Nombre:'dato3' , ID: 1002},
	  {Nombre:'dato4' , ID: 1004},
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
